module.exports = __webpack_public_path__ + "img/AI_LOGO2.f66fcf80.png";